import { Sparkles } from "lucide-react";

/**
 * Floating "Draw It Up" action button shown to Chalkboard-tier coaches.
 * Anchored above the bottom nav (bottom: 92).
 */
export function DrawItUpFab({ onClick }) {
  return (
    <button
      type="button"
      data-testid="draw-it-up-fab"
      aria-label="Draw It Up"
      onClick={onClick}
      style={{
        position: "fixed", right: 18, bottom: 92, zIndex: 40,
        width: 56, height: 56, borderRadius: 999,
        background: "var(--chalk-board)", color: "var(--chalk-white)",
        border: "0.5px solid rgba(245,240,232,0.18)",
        boxShadow: "0 6px 18px rgba(28,43,30,0.32)",
        display: "flex", alignItems: "center", justifyContent: "center",
        cursor: "pointer", transition: "transform 140ms ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-2px)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
    >
      <Sparkles size={22} aria-hidden="true" />
    </button>
  );
}
